import axiosInstance from "../helpers/axios";

// returns the User token if valid
const getloginToken = async(email: string,password: string)=>{
    try{
        const tokenData = await axiosInstance.post("/login/loginAdmin", {
            'email': email,
            'password': password 
        });        
        return tokenData;
    }
    catch(error){
        console.log(error);
    }
}

const getAdmin = async()=>{
    try{
        const data = await axiosInstance.get("/login/getLogin");
        return data;
    }catch(error){
        console.log(error);
    }
}

export {getloginToken, getAdmin};
